import { useState, useEffect } from 'react';
import { Grid, Box, Typography, Divider, Button, CircularProgress } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { deleteProductAPI } from 'api/OmsOrdermgmtWebServices';
import { deleteProductObj,setProductDeleteproductModal, updatePharmaorderObj, updatePoObj } from 'store/slice/PharmaSlice';

export default function DeleteProduct() {
    const dispatch = useDispatch();
    const [apiInProgress, setApiInProgress] = useState(false);
    const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
    const [msg, setMsg] = useState('');
    const [msgType, setMsgType] = useState(1);

    const deleteSuccessCallBack = (response) =>{
        setApiInProgress(false);
        
        dispatch(deleteProductObj(response.productInfo.id));
        if (response.pharmaorderInfo!==null) dispatch(updatePharmaorderObj(response.pharmaorderInfo));
        if (response.poInfo!==null) dispatch(updatePoObj(response.poInfo));

        setMsgType(1);
        setMsg("Product '"+response.productInfo.title+"' is deleted successfully !!!");
    }
    const deleteFailureCallBack = (response) =>{
        setApiInProgress(false);
        setMsgType(0);
        setMsg(response);

    }
    const handleProductDelete = () => {
        setApiInProgress(true);
        deleteProductAPI({
            "productId":productObj.id,
        }, deleteSuccessCallBack, deleteFailureCallBack)
    }
    const closeDeleteModal = () =>{
        dispatch(setProductDeleteproductModal(false));
    }

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Box padding={2} sx={{backgroundColor: 'white', borderRadius: 4, boxShadow: 3}}>
                    <Grid lg={12} xs={12} container direction="column">
                        <Grid container display="flex" direction="column" justifyContent="center" alignItems="center" sx={{ minWidth: '285px', minHeight: '200px' }}>
                            <Grid item>
                                <Typography variant="h6" component="h2" >
                                    CONFIRMATION
                                </Typography>
                            </Grid>
                            <Divider sx={{width:'100%'}}/>
                            <Grid item>
                            <Typography id="modal-modal-description" sx={{ mt: 10 }}>
                                Are you sure to delete '{productObj.productname}' ?
                            </Typography>
                            </Grid>
                        </Grid>
                        <Box height="50px" sx={{ width: '100%' }}></Box>
                        <Divider />
                        <Grid padding={2}>
                            {
                                apiInProgress ?
                                    <Grid container display="flex" direction="row" justifyContent="center">
                                        <CircularProgress padding={2} />
                                    </Grid>
                                    :
                                    msg!==''
                                        ?<Grid sx={{textAlign:'center' }}>
                                            <Typography color={msgType?'green':'red'} >{msg}</Typography>
                                        </Grid>
                                        :
                                        <Grid container display="flex" direction="row" justifyContent="space-between">
                                            <Button variant="outlined" onClick={() => handleProductDelete()}> Yes</Button>
                                            <Button variant="outlined" onClick={() => closeDeleteModal()}> No</Button>
                                        </Grid>
                            }
                        </Grid>
                    </Grid>
                </Box>

            </Box>
        </Box>
    )
}